import { LandingHero } from "./components/LandingHero";
import { LandingMainContent } from "./components/LandingMainContent";

export const LandingTemplate = ({ heroData, mainData }) => {
  return (
    <>
      {heroData && <LandingHero data={heroData} />}
      {mainData && <LandingMainContent data={mainData} />}
    </>
  );
};
